var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "block-shield-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 1.22754L52.5116 6.12987V25.3402C52.511 32.2612 50.1114 38.9679 45.7216 44.3185C41.3317 49.6691 35.223 53.3326 28.4355 54.6854L27.9999 54.7722L27.5644 54.6854C20.7769 53.3326 14.6682 49.6691 10.2783 44.3185C5.88844 38.9679 3.4889 32.2612 3.48828 25.3402V6.12987L27.9999 1.22754ZM7.94495 9.78347V25.3398C7.94495 25.3399 7.94495 25.3399 7.94495 25.34C7.94552 31.2302 9.9877 36.938 13.7238 41.4917C17.3657 45.9307 22.3978 49.0054 27.9999 50.2239C33.6021 49.0054 38.6342 45.9307 42.2761 41.4917C46.0122 36.938 48.0544 31.2302 48.0549 25.34C48.0549 25.3399 48.0549 25.3399 48.0549 25.3398V9.78346L27.9999 5.77247L7.94495 9.78347Z",
    fill: "#2895EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 19.0983C23.0838 19.0983 19.0984 23.0837 19.0984 28C19.0984 32.9163 23.0838 36.9017 28.0001 36.9017C32.9163 36.9017 36.9017 32.9163 36.9017 28C36.9017 23.0837 32.9163 19.0983 28.0001 19.0983ZM14.6417 28C14.6417 20.6224 20.6225 14.6417 28.0001 14.6417C35.3777 14.6417 41.3584 20.6224 41.3584 28C41.3584 35.3776 35.3777 41.3583 28.0001 41.3583C20.6225 41.3583 14.6417 35.3776 14.6417 28Z",
    fill: "#2895EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.631 34.2177L34.311 18.5377L37.4623 21.689L21.7823 37.369L18.631 34.2177Z",
    fill: "#2895EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockShield);
export default __webpack_public_path__ + "static/media/block-shield.3ffdf8127431870e2fc2a78bcae8284c.svg";
export { ForwardRef as ReactComponent };